import type { FaireProductEntity } from "../../entity_types/product";

export const p_bcdcsmzs42: FaireProductEntity = {
  token: "p_bcdcsmzs42",
  type: "product",
  name: "One Fish Two Fish Beaded Earrings",
  brandToken: "b_7f43382b",
  brandName: "Altiplano",
  imageUrl:
    "https://cdn.faire.com/fastly/dfe9c8288f86fa56a0e12e094369d577303c932b974431af041d912e8d933f9b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ecdce8a822743574e1fd89cb7c769f2487dd53cc294ffcc73e555457cc47cdc.jpeg",
    "https://cdn.faire.com/fastly/ab04da6fdd93946329206047722a36655ae665c25d30e4212c77f4631eaff707.jpeg",
  ],
  priceDollars: 9,
  description:
    'Festive fish earrings are hand beaded in three delightful color ways.\nSecurely attaches with surgical steel French hook ear wires.\n2.5" L x 0.5" W\nThe One Fish Two Fish Beaded Earrings are handmade in a fair trade workshop in Guatemala.',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:00.168Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
